(() => {
 if (window.mceEinkPanelInstalled) return;
 window.mceEinkPanelInstalled = true;
 let trigger, previousOverflow, active;
 const close = () => { if (active?.open) active.close(); };
 document.addEventListener('click', event => {
  const link = event.target.closest('[data-mce-eink-open]');
  if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
   const panel = document.getElementById(link.getAttribute('aria-controls'));
   if (!panel?.showModal) return;
   event.preventDefault(); trigger = link; active = panel; previousOverflow = document.documentElement.style.overflow;
   const savedPosition = {left: window.scrollX, top: window.scrollY, behavior: 'instant'};
   panel.showModal(); panel.scrollTop = 0; document.documentElement.style.overflow = 'hidden';
   panel.querySelector('[data-mce-eink-close]').focus({preventScroll:true});
   panel.addEventListener('close', () => { document.documentElement.style.overflow = previousOverflow; trigger?.focus({preventScroll:true}); window.scrollTo(savedPosition); active = null; }, {once:true});
  }
  if (event.target.closest('[data-mce-eink-close]')) close();
  if (active && event.target === active) { const r = active.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); }
  const productLink = event.target.closest('.mce-eink-panel a');
  if (productLink && !new URL(productLink.href).search && new URL(productLink.href).pathname === location.pathname) { event.preventDefault(); close(); }
 });
 document.addEventListener('shopify:section:unload', event => { if (active && event.target.contains(active)) close(); });
})();
